<div class="w-100 c-sidebar" [class.out]="menuSideBar">
  <div class="menuSideBar" (click)="menuSideBar = !menuSideBar" [class.out]="menuSideBar" *ngIf="!lmService.sideNavToggle">
    <i class="pi pi-angle-right" *ngIf="!menuSideBar"></i>
    <i class="pi pi-angle-left" *ngIf="menuSideBar"></i>
  </div>
  <div class="body-details pt-0 pl-0" style="border: none; padding-right: 0px !important">
    <ul class="gs-accordion--list">
      <li class="level-1 level-heading" routerLinkActive="active">
        <h2
          class="d-flex align-items-center pl-0"
          style="
            font-size: 24px;
            font-weight: 600;
            padding-left: 24px !important;
            padding-bottom: 24px;
            padding-top: 27px;
            border-bottom: solid 1px #e8eaec !important;
          ">
          Contact
        </h2>
        <ul class="scrol_contact_sidebar level-2 list-unstyled pt-3" id="accordion" style="margin-left: 24px !important; padding-right: 16px">
          <!-- 09 - Contacts -->
          <li routerLinkActive="level-2-active mr-2" *ngFlag="'contacts'" [routerLinkActiveOptions]="{ exact: true }">
            <a
              href="javascript:void(0)"
              *ngxPermissionsOnly="['contact.view', 'contact.add', 'contact.edit', 'contact.delete']"
              routerLink="/setting/office-contact"
              routerLinkActive="active-highlight">
              <img [src]="images?.id_card_icon" alt="contacts" width="15px" class="mr-2" />Contacts</a
            >
            <div id="contacts" class="collapse" data-parent="#accordion" routerLinkActive="show">
              <!-- "All" from allContactData[0] -->
              <li class="d-flex align-items-center justify-content-between cursor-pointer">
                <a href="javascript:void(0);" [ngClass]="{ active: role_id === 'All' }" (click)="clickContactFilter('All')">
                  <img [src]="images?.huge_icon" alt="All" width="15px" class="mr-2" />
                  {{ allContactData[0]?.name }} ({{ allContactData[0]?.count }})
                  <img *ngIf="loading && !showContactType" [src]="common_images?.loader_gif" alt="" style="width: 25px; float: right" />
                </a>
              </li>
              <ul class="contact-child" *ngFor="let role of newContactType; let i = index">
                <!-- Top level: Individual / Company -->
                <li class="d-flex align-items-center justify-content-between cursor-pointer pl-1">
                  <a
                    href="javascript:void(0);"
                    tooltipPosition="top"
                    [pTooltip]="role?.name + ' (' + role?.count + ')'"
                    [ngClass]="{ active: role_id === role?.name }"
                    (click)="clickContactFilter(role?.name)">
                    <img [src]="images?.huge_icon" alt="All" width="15px" class="mr-2" />
                    {{ role?.name }} ({{ role?.count }})
                    <img *ngIf="loading && !showContactType" [src]="common_images?.loader_gif" alt="" style="width: 25px; float: right" />
                  </a>
                  <i class="pi" [ngClass]="{ 'pi-angle-down': !role.isOpen, 'pi-angle-up': role.isOpen }" (click)="toggleContactGroup(i, $event)">
                  </i>
                </li>

                <!-- 2nd Level: Types inside Individual or Company (Agent, Buyer, etc.) -->
                <li *ngFor="let cont_type of role?.types" class="cursor-pointer cs-pl-2" [hidden]="!role.isOpen">
                  <a
                    href="javascript:void(0)"
                    tooltipPosition="top"
                    [pTooltip]="
                      cont_type?.name === 'Unknown'
                        ? cont_type?.groupType === 'individual'
                          ? 'No Contact Type' + ' (' + cont_type?.count + ')'
                          : cont_type?.groupType === 'company'
                            ? 'No Company Type' + ' (' + cont_type?.count + ')'
                            : 'Unknown'
                        : cont_type?.name + ' (' + cont_type?.count + ')'
                    "
                    [ngClass]="{ active: role_id === cont_type?.name && groupType === cont_type?.groupType }"
                    (click)="clickContactFilter(cont_type, cont_type?.name)"
                    class="d-flex align-items-center">
                    <!-- Conditional image icons -->
                    <img [src]="images?.agency_icon" alt="agency" width="14px" class="mr-2" *ngIf="cont_type.name === 'Agency'" />
                    <img [src]="images?.user_icon" alt="agent" width="14px" class="mr-2" *ngIf="cont_type.name === 'Agent'" />
                    <img [src]="images?.user_icon" alt="buyer" width="14px" class="mr-2" *ngIf="cont_type.name === 'Buyer'" />
                    <img [src]="common_images?.user_business_icon" alt="client" width="14px" class="mr-2" *ngIf="cont_type.name === 'Client'" />
                    <img [src]="common_images?.project_1" alt="company" width="14px" class="mr-2" *ngIf="cont_type.name === 'Company'" />
                    <img
                      [src]="images?.constructor_icon"
                      alt="developers"
                      width="14px"
                      class="mr-2"
                      *ngIf="cont_type.name === 'Developer' || cont_type.name === 'Developers'" />
                    <img [src]="common_images?.right_user_icon" alt="owner" width="14px" class="mr-2" *ngIf="cont_type.name === 'Owner'" />
                    <img [src]="images?.people_upload_icon" alt="seller" width="14px" class="mr-2" *ngIf="cont_type.name === 'Seller'" />
                    <img [src]="images?.user_icon" alt="solicitor" width="14px" class="mr-2" *ngIf="cont_type.name === 'Solicitor'" />
                    <i class="mr-2 pi pi-exclamation-triangle f-12" *ngIf="cont_type.name === 'Unknown'"></i>

                    <p class="f-10">
                      {{
                        cont_type?.name === 'Unknown'
                          ? cont_type?.groupType === 'individual'
                            ? 'No Contact Type'
                            : cont_type?.groupType === 'company'
                              ? 'No Company Type'
                              : 'Unknown'
                          : cont_type?.name
                      }}
                      ({{ cont_type?.count }})
                    </p>
                    <!-- {{ cont_type?.name == 'Unknown' ? 'Unassigned' : cont_type?.name }} ({{ cont_type?.count }}) -->
                  </a>
                </li>
              </ul>
            </div>
          </li>
          <!-- 01 - Users -->
          <li routerLinkActive="level-2-active mr-2" *ngFlag="'users'" [routerLinkActiveOptions]="{ exact: true }">
            <a
              class="h3-heading"
              tooltipPosition="top"
              [pTooltip]="'Users'"
              href="javascript:void(0)"
              routerLinkActive="active-highlight"
              routerLink="/setting/users"
              *ngxPermissionsOnly="['user.view', 'user.add', 'user.delete', 'user.edit']">
              <img [src]="common_images?.user_icon" alt="contacts" width="15px" class="mr-2" />Users
            </a>
            <div id="collapse1" class="collapse" data-parent="#accordion" routerLinkActive="show">
              <div class="my-2 site-searchbox position-relative with-left-icon">
                <input type="text" placeholder="Search User Role" class="site-input" (input)="filterItem(query, 'roles')" [(ngModel)]="query" />
                <i class="pi pi-search cp" *ngIf="!query"></i>
                <i class="pi pi-times cp" *ngIf="query" (click)="assignCopy('roles'); query = ''"></i>
              </div>
              <ul class="contact-child">
                <li class="d-flex align-items-center justify-content-between cursor-pointer" (click)="showUser = !showUser">
                  <a
                    href="javascript:void(0);"
                    [ngClass]="{ active: role_id === '' }"
                    (click)="clickUserFilter('role', 1, 20, (role_id = ''), query)">
                    All ({{ allCount }})
                    <img *ngIf="loading" [src]="common_images?.loader_gif" alt="" style="width: 25px; float: right" />
                  </a>
                  <i class="pi {{ !showUser ? 'pi-angle-down' : 'pi-angle-up' }}"></i>
                </li>
                <ng-container *ngIf="showUser">
                  <li *ngFor="let role of filteredRoles">
                    <a
                      href="javascript:void(0)"
                      tooltipPosition="top"
                      [pTooltip]="role.name + ' (' + role.user_count + ')'"
                      [ngClass]="{ active: role_id === (role._id ? role._id : role.id) }"
                      (click)="clickUserFilter(role, 1, 20, (role_id = role._id ? role._id : role.id), query)"
                      >{{ role.name }} ({{ role.user_count }})</a
                    >
                  </li>
                </ng-container>
              </ul>
            </div>
          </li>
          <!-- 02 - Roles -->
          <!-- 02 - Groups -->
          <li routerLinkActive="level-2-active mr-2" *ngFlag="'groups'" [routerLinkActiveOptions]="{ exact: true }">
            <a
              href="javascript:void(0)"
              routerLinkActive="active-highlight"
              *ngxPermissionsOnly="['groups.manage']"
              routerLink="/setting/groups"
              tooltipPosition="top"
              [pTooltip]="'Groups'">
              <img [src]="common_images?.user_group_icon" alt="contacts" width="15px" class="mr-2" />Groups
            </a>
          </li>
          <!-- 03 - Offices -->
          <li routerLinkActive="level-2-active mr-2" *ngFlag="'offices'" [routerLinkActiveOptions]="{ exact: true }">
            <a
              href="javascript:void(0)"
              routerLinkActive="active-highlight"
              *ngxPermissionsOnly="['offices.manage']"
              routerLink="/setting/offices"
              tooltipPosition="top"
              [pTooltip]="'Offices'">
              <img [src]="images?.office_icon" width="15px" class="mr-2" />Offices
            </a>
          </li>
          <!-- 04 - Access -->
          <li routerLinkActive="level-2-active mr-2" *ngFlag="'access'" [routerLinkActiveOptions]="{ exact: true }">
            <a
              href="javascript:void(0)"
              routerLinkActive="active-highlight"
              *ngxPermissionsOnly="['setting.access.setup']"
              routerLink="/setting/setup/permission"
              tooltipPosition="top"
              [pTooltip]="'Access'">
              <img [src]="common_images?.lock_icon" alt="contacts" width="15px" class="mr-2" />Access
            </a>
          </li>

          <!-- 06 - Staffs -->
          <li routerLinkActive="level-2-active mr-2" *ngFlag="'staff'" [routerLinkActiveOptions]="{ exact: true }">
            <a
              href="javascript:void(0)"
              routerLinkActive="active-highlight"
              tooltipPosition="top"
              [pTooltip]="'Staff'"
              *ngxPermissionsOnly="['staff.view', 'staff.add', 'staff.delete', 'staff.edit']"
              routerLink="/setting/office-staff">
              <img [src]="common_images?.right_user_icon" alt="owner" width="15px" class="mr-2" />Staff</a
            >
            <div id="staffs" class="collapse" data-parent="#accordion" routerLinkActive="show">
              <ul class="contact-child">
                <li class="d-flex align-items-center justify-content-between cursor-pointer" (click)="showStaff = !showStaff">
                  <a href="javascript:void(0);" [ngClass]="{ active: role_id === '' }" (click)="clickStaffFilter('staff', (role_id = ''))">
                    All
                    <span *ngIf="(allCount || teams?.length) > 0"> ({{ allCount > 0 ? allCount : teams?.length }}) </span>
                    <img *ngIf="loading" [src]="common_images?.loader_gif" alt="" style="width: 25px; float: right" />
                  </a>
                  <i class="pi {{ !showStaff ? 'pi-angle-down' : 'pi-angle-up' }}"></i>
                </li>
                <ng-container *ngIf="showStaff">
                  <li *ngFor="let staff of filteredStaff">
                    <a
                      href="javascript:void(0)"
                      tooltipPosition="top"
                      [pTooltip]="staff.name + ' (' + staff.user_count + ')'"
                      [ngClass]="{ active: role_id === (staff._id ? staff._id : staff.id) }"
                      (click)="clickStaffFilter(staff, (role_id = staff._id ? staff._id : staff.id))">
                      {{ staff.name }}
                      <span *ngIf="staff.user_count > 0">({{ staff.user_count }})</span>
                    </a>
                  </li>
                </ng-container>
              </ul>
            </div>
          </li>
          <li routerLinkActive="level-2-active mr-2" *ngFlag="'teams'" [routerLinkActiveOptions]="{ exact: true }">
            <a
              href="javascript:void(0)"
              routerLinkActive="active-highlight"
              *ngxPermissionsOnly="['team.manage', 'team.view']"
              routerLink="/setting/teams">
              <img [src]="common_images?.user_group_icon" alt="owner" width="15px" class="mr-1" />
              Teams ({{ teams?.length }})
            </a>
          </li>
        </ul>
      </li>
    </ul>
  </div>
</div>
